<template>
  <div id="awardSetting" >
    <div class="decorate"></div>
    <div class="con-center">
      <div class="title">
        <span>奖项设置</span>
      </div>
      <div class="award-setting-con">
        <div class="award-setting" :class="award.class" v-for="award in awardSettingData">
          <div class="rank">
            <p class="total">{{award.total}}</p>
            <p class="ranking">{{ award.ranking}}<span>{{ award.rankingNum }}</span>名</p>
          </div>
          <img :src="award.img" :class="award.class">
          <div class="award-con-info">
            <p>{{ award.name }}</p>
            <p>价值<span> {{ award.price }}</span> 元</p>
            <p class="add" v-if="award.add"><span>{{ award.add }}</span></p>
            <p v-if="award.money"><span>{{ award.money }}</span></p>
          </div>
        </div>
      </div>

      <div class="main-button" >
        <span @click="toWinnersList">查看获奖名单</span>
        <p>*奖项的评定视参赛作品质量而定，可能出现部分奖项空缺</p>
        <p>奖金说明：全部奖金均为税前金额，以人民币为单位结算，奖金由北京站酷网络科技有限公司代扣代缴个人所得税。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AwardSetting",
  data() {
    return{
      awardSettingData: [
        {class: "first", total: "共创2047", ranking: "金奖", rankingNum: "1", img: require("../assets/images/as_con1_img.png"),
          name: "戴尔 Precision 5470 工作站", price: "25,499", add: "+", money: "30,000元" },
        {class: "second", total: "共创2047", ranking: "银奖", rankingNum: "2", img: require("../assets/images/as_con2_img.png"),
          name: "戴尔 Precision 3571 工作站", price: "10,499", add: "+", money: "10,000元" },
        {class: "third", total: "共创2047", ranking: "铜奖", rankingNum: "5", img: require("../assets/images/as_con3_img.png"),
          name: "戴尔 UltraSharp 24 系列显示器", price: "4,269", add: "+", money: "1,000元" },
        {class: "fourth", total: "共创2047", ranking: "最佳人气奖", rankingNum: "5", img: require("../assets/images/as_con4_img.png"),
          name: "戴尔 UltraSharp 4k 网络摄像头", price: "2,169", add: "", money: "" },
        {class: "fifth", total: "共创2047", ranking: "助力达人奖", rankingNum: "50", img: require("../assets/images/as_con5_img.png"),
          name: "戴尔全尺寸无线鼠标 - MS300", price: "199", add: "", money: "" }
      ]
    }
  },
  methods: {
    toWinnersList() {
      this.$router.push({path:'/winnersList'});
    }
  }
}
</script>

<style scoped lang="less">
  #awardSetting{
    position: relative;
    width: 100%;
    background-size: 100% 100%;
    font-size: 17px;
    .decorate{
      position: absolute;
      background-size: 100% 100%;
      z-index: 1;
    }
    .con-center{
      height: 100%;
      margin: 0 auto;
      position: relative;
      padding: 0 10%;
      .title{
        position: absolute;
        content: '';
        width: 255px;
        height: 39px;
        top: -35px;
        left: 0;
        right: 0;
        margin: auto;
        background: url("../assets/images/as_title.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        span{
          line-height: 82px;
          font-size: 25px;
          color: #14456e;
          font-weight: bold;
        }
        &:after{
          position: absolute;
          content: '';
          width: 240px;
          height: 72px;
          top: 6px;
          left: 8px;
          background: url("../assets/images/as_text.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .award-setting-con{
        position: relative;
        max-width: 900px;
        margin: auto;
        .award-setting{
          position: absolute;
          text-align: center;
          &.first{
            z-index: 4;
            background-size: auto;
          }
          &.second{
            z-index: 3;
            background-size: 100% 100%;
          }
          &.third{
            z-index: 2;
            background-size: 100% 100%;
          }
          &.fourth{
            z-index: 4;
            background-size: 100% 100%;
          }
          &.fifth{
            z-index: 3;
            background-size: 100% 100%;
          }
          .rank{
            color: #5c75a6;
            font-weight: bold;
            letter-spacing: 1px;
            position: absolute;
            top: -72px;
            text-align: center;
            width: 100%;
            .total{
              height: 22px;
            }
          }
          img{
            width: 155px;
            height: 100px;
            &.second{
              padding-left: 25px;
            }
          }
          .award-con-info{
            p{
              //font-size: 15px;
              color: #5c75a6;
              //line-height: 25px;
              span{
                font-weight: bold;
              }
            }
          }
        }
      }
      .main-button{
        width: 100%;
        text-align: center;
        padding-top: 640px;
        position: absolute;
        bottom: 56px;
        left: 0;
        cursor: pointer;
        span{
          display: inline-block;
          width: 183px;
          height: 47px;
          color: #fff;
          line-height: 47px;
          font-size: 17px;
          background: url("../assets/images/match_button.png") no-repeat;
          background-size: 100% 100%;
          //font-weight: normal;
        }
        p{
          padding-top: 10px;
          color: #1a6cb0;
          font-weight: bold;
        }
      }
    }
  }
  //pc
  @media (min-width: 992px){
    #awardSetting{
      height: 925px;
      background-image: url("../assets/images/as_bg.png");
      //background-size:  auto;
      &:before{
        content: '';
        position: absolute;
        bottom: -45px;
        right: 176px;
        transform: rotateY(180deg);
        width: 174px;
        height: 150px;
        z-index: 2;
        background: url("../assets/images/decorate1.png") no-repeat;
        background-size: 100% 100%;
      }
      .decorate{
        bottom: -100px;
        width: 483px;
        height: 626px;
        background: url("../assets/images/as_bg2.png") no-repeat;
        background-size: 100% 100%;
      }
      .con-center{
        max-width: 1160px;
        .award-setting-con{
          width: 30px;
          height: 30px;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          position: absolute;
          .award-setting{
            //margin: auto;
            //width: 508px;
            //height: 481px;
            width: 281px;
            height: 233px;
            position: absolute;
            &.first{
              left: -381px;
              top: -260px;
              //margin-left: 66px;
              background: url("../assets/images/as_con1.png") no-repeat;
            }
            &.second{
              left: -141px;
              top: -260px;
              background: url("../assets/images/as_con2.png") no-repeat;
            }
            &.third{
              left: 99px;
              top: -260px;
              background: url("../assets/images/as_con3.png") no-repeat;
              .award-con-info{
                left: 115px;
              }
            }
            &.fourth{
              left: -261px;
              top: 60px;
              background: url("../assets/images/as_con4.png") no-repeat;
              img{
                width: 124px;
                height: 100px;
                padding-top: 26px;
              }
            }
            &.fifth{
              left: -20px;
              top: 60px;
              background: url("../assets/images/as_con5.png") no-repeat;
              img{
                padding-top: 30px;
              }
            }
            .rank{
              //top: -4px;
              //left: 64px;
              .total{
                font-size: 17px;
              }
              .ranking{
                font-size: 28px;
                span{
                  font-size: 31px;
                }
              }
            }
            img{
              padding-top: 12px;
            }
            .award-con-info{
              p{
                font-size: 14px;
                line-height: 24px;
                &.add{
                  line-height: 18px;
                }
                span{
                  font-size: 18.5px;
                }
              }
            }
          }
        }
        .main-button{
          span{
            font-weight: normal;
          }
          p{
            font-size: 14px;
          }
        }
      }
    }
  }
  //mobile
  @media (max-width: 992px) {
    #awardSetting{
      height: 920px;
      background-image: url("../assets/images/as_bg_mobile.png");
      .decorate{
        bottom: 34px;
        width: 112px;
        height: 270px;
        background: url("../assets/images/as_bg2_mobile.png") no-repeat;
      }
      .con-center{
        .title{
          background-size: 100% 100%;
        }
        &:after{
          background-size: 100% 100%;
        }
        .award-setting-con{
          width: 1px;
          height: 1px;
          left: 0;
          right: 0;
          top: -18%;
          bottom: 0;
          position: absolute;
          .award-setting{
            width: 251px;
            height: 210px;
            //&:before{
            //  top: -66px;
            //  left: -32px;
            //  width: 439px;
            //  height: 455px;
            //  background: url("../assets/images/as_con_shadow_mobile.png") no-repeat;
            //}
            &.first{
              left: -356px;
              top: -200px;
              //margin-left: 66px;
              background: url("../assets/images/as_con1.png") no-repeat center;
              background-size: cover;
            }
            &.second{
              left: -125px;
              top: -200px;
              background: url("../assets/images/as_con2.png") no-repeat;
              background-size: cover;
            }
            &.third{
              left: 109px;
              top: -200px;
              background: url("../assets/images/as_con3.png") no-repeat;
              background-size: cover;
            }
            &.fourth{
              right: -10px;
              top: 110px;
              background: url("../assets/images/as_con4.png") no-repeat;
              background-size: cover;
              img{
                width: 124px;
                height: 100px;
                padding-top: 24px;
              }
            }
            &.fifth{
              left: -10px;
              top: 110px;
              background: url("../assets/images/as_con5.png") no-repeat;
              background-size: cover;
              img{
                padding-top: 24px;
              }
            }
            .rank{
              width: 100%;
              .total{
                font-size: 15px;
                height: 20px;
              }
              .ranking{
                font-size: 24px;
                span{
                  font-size: 30px;
                }
              }
            }
            .award-con-info{
              p{
                font-size: 16px;
                line-height: 20px;
              }
            }
            img{
              width: 155px;
              height: 100px;
              padding-top: 13px;
              &.second{
                padding-left: 25px;
              }
            }
          }
        }
        .main-button{
          span{
            font-weight: normal;
          }
          p{
            font-size: 15px;
          }
        }
      }
    }
  }
  @media (max-width:1500px) and (min-width:992px){
    #awardSetting{
      .decorate{
       background-size: 80% 80%;
      }
    }
  }
</style>
